import { render, staticRenderFns } from "./TemplateEditorAddPlaceholder.vue?vue&type=template&id=58dd7d86&scoped=true"
import script from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TemplateEditorAddPlaceholder.vue?vue&type=script&lang=ts"
import style0 from "./TemplateEditorAddPlaceholder.vue?vue&type=style&index=0&id=58dd7d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd7d86",
  null
  
)

export default component.exports